import { Component, OnInit } from '@angular/core';
import { Kurs } from '../_models/kurs';
import { KursService } from '../_services/kurs.service';
import { InhalteService } from '../_services/inhalte.service';
import { Klassenbuch } from '../_models/klassenbuch';
import { FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from '../_services/authentication.service';
//import { MatSelectChange } from '@angular/material';
//import { TeilnehmerService } from '../_services/teilnehmer.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit
{
  futureChecked: boolean = false;
  kursstandorte: string[];
  kurseAmStandort: Kurs[];
  selected: boolean;
  kursTagFormControl: FormControl = new FormControl('', [Validators.required]);
  klassenbuecher:Klassenbuch[]
selectedKurse:any;
  constructor(private kService: KursService, private iService: InhalteService, private aService:AuthenticationService ) {}
  ngOnInit()
  {
    this.loadKurse();
    this.klassenbuecher = [];
    
  }
  loadKurse()
  {
    this.kService.getKursStandorte().subscribe(x => {
      this.kursstandorte = x;
    });
  }
  ortChanged(siteSelected)
  {
    this.kService.getKursByStandort(siteSelected).subscribe(x => this.kurseAmStandort = x);
    this.selected = true;
    //console.log("changed " + siteSelected);
  }
  selectedKursChanged(events)
  {
    this.iService.getInhaltebykurs(this.kurseAmStandort.find((k) => k.kursName === events.target.value)).subscribe(
      x => this.klassenbuecher = x,
      err => console.log(err),
      () => {
        this.klassenbuecher = this.klassenbuecher.sort(
          (a, b) => {
            if (a.eintragsDatum > b.eintragsDatum) return -1; else return 1;
          })
      });
    //console.log(this.selectedKurse);
    //console.log(this.kurseAmStandort);
    //console.log(events)
  }

  ferienFilter: IContentFilter = (k, i, a) => { return this.futureChecked || k.eintragsDatum < new Date().toISOString().substr(0, 10)};

  OnFutureChecked(event) {
    this.futureChecked = !this.futureChecked;
    console.log(this.futureChecked);
  }

}

interface IContentFilter {
  (klb: Klassenbuch, index: number, array: Klassenbuch[]): boolean;
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts